import { Component, Pipe, PipeTransform } from '@angular/core';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { Lead, LeadForm } from '../model/model.lead';
import { FormBuilder } from '@angular/forms';
import { LeadService } from '../lead.service';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ViewleadComponent } from '../viewlead/viewlead.component';
import { AlertComponent } from '../../shared/alert/alert.component';
import { Theme } from '../../shared/service/AutoTheme';
import { BehaviorSubject } from 'rxjs';
import { saveAs } from "file-saver";
import { SelectionModel } from '@angular/cdk/collections';
import { ExportleadsComponent } from '../exportleads/exportleads.component';
import { SingleleadComponent } from '../singlelead/singlelead.component';
import { SummaryService } from '../lead.service';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
  selector: 'app-discovery',
  templateUrl: './discovery.component.html',
  styleUrls: ['./discovery.component.css'],
  animations: [
    trigger('widthGrow', [
      state(
        'closed',
        style({
          border: "0px",
          height: "0px",
          margin: "0px 0px 20px 0px",
        })
      ),
      state(
        'open',
        style({

          margin: "0px 0px 20px 0px",
        })
      ),
      // transition('=>', animate(500)),
    ]),
  ],
})
export class DiscoveryComponent extends AppComponentClass<Lead, LeadForm>
{
  public automation = [];
  public keydata: number;
  public keytype: number;
  strfltr: any;

  statelist: any;
  countylist: any;
  citylist: any;
  ziplist: any;
  groupdata = [];
  checkedLeads = [];
  agentList = [];
  allleads: any = [];
  alltemplate: Lead[] = JSON.parse(sessionStorage.getItem("allcampaign"));
  templatedata: any = [];
  campiagn_id: string = '-1';
  ischecked: boolean = false;
  checkallbox: boolean = false;
  public currworkflow: number = 1;
  fieldArray: any[] = [];
  statusid: any;
  freeleads: any;
  aTagsData = [];
  leadscriptList: any = [];
  tagslist: Lead[];
  leadstatus_id: number = -1;
  leadscript_id: number = -1;
  agent_id: number = -1;
  tag_id: number;
  filterIconVal: any = '2';

  // @objects for leads filter
  fCampIds: any[] = []
  fAgentIds: any[] = []
  fLdStatus: any = -1
  fLdType: number = -1

  // @objects for checked leads actions
  aCampIds: any[] = []
  aAgentId: number = -1
  aLdStatus: number = -1
  aLdType: number = -1
  allfilter: any = [];

  allChk: boolean = false
  pgSize: number = 25
  pgSI: number = 0
  pgEI: number = 0
  pgSizeOpt: number[] = [25, 50, 100]

  public agentlead: any;
  aLeads: number = 0
  taLeads: number = 0
  fLeads: number = 0
  unLeads: number = 0
  freeLeads: number = 0
  BlankLeads: number = 0

  leadsColumns: any = {}

  dialerlist: any[] = []
  d1Ttl: string = ""
  d2Ttl: string = ""
  d3Ttl: string = ""

  lS1: any[] = []
  lS2: any[] = []
  lS3: any[] = []
  vLS1: number = -1
  vLS2: number = -1
  vLS3: number = -1

  lScript1: any[] = []
  lScript2: any[] = []
  lScript3: any[] = []
  vLSrc1: number = -1
  vLSrc2: number = -1
  vLSrc3: number = -1

  isD1: boolean = false
  isD2: boolean = false
  isD3: boolean = false

  isACt: boolean = false
  campIds: any[] = []

  acLeadStatus: any[] = []
  acLeadSripts: any[] = []

  vLeadStatus: any[] = []
  vLeadSripts: any[] = []

  leadFields: any = {
    RawHeader: [],
    Dialers: []
  }

  public __leaddata = new BehaviorSubject<any>([]);
  public leaddata = this.__leaddata.asObservable();
  allcamp = JSON.parse(sessionStorage.getItem("allcampaign"))
  currcampflag: any;
  campid: any;
  auto: any;
  visible: boolean = false;
  fauto: any = '';
  autoDelete: any = [];
  aAgentId_forcheck: any;
  selectionAmount: number;
  currcampId: any;
  constructor(protected data: LeadService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, public dialog: MatDialog, private theme: Theme, private route: ActivatedRoute, protected samService: SummaryService) {
    super(data, router, fb, msg);

    this.keydata = parseInt(sessionStorage.getItem('userid'));
    this.keytype = parseInt(sessionStorage.getItem('type'));
    this.currcampId = sessionStorage.getItem('currcampaign');
    this.campiagn_id = Array.isArray(this.alltemplate) && this.alltemplate.length > 0 ? this.alltemplate[0].id.toString() : '0'

    if (this.keytype == 4) {
      this.displayedColumns = ['checkbox', 'fullname', 'state', 'county', 'uploaded_by', 'assign_date', 'created_date', 'automation', 'actions']
    } else {
      this.displayedColumns = ['checkbox', 'fullname', 'state', 'county', 'assign_date', 'created_date', 'automation', 'actions']
    }
  }

  gInit(): void {
    this.fCampIds = []
    this.fAgentIds = []
    this.fLdStatus = [-1]
    this.fLdType = -1
    this.fauto = ''
    this.disableLeadStatus([]);
    this.aCampIds = []
    this.aAgentId = -1
    this.aLdStatus = -1
    this.aLdType = -1

    this.vLS1 = -1
    this.vLS2 = -1
    this.vLS3 = -1

    this.vLSrc1 = -1
    this.vLSrc2 = -1
    this.vLSrc3 = -1

    this.allChk = false
    this.allfilter = []

  }

  matTbInit(): void {
    this.changePage({
      pageIndex: 0,
      pageSize: this.pgSize
    })
  }

  ngOnInit(): void {
    this.gInit()
    if (this.fCampIds.length > 0) {
      console.log("sid work", this.fCampIds);
      console.log("sid1", this.allfilter);
    }

    //get Automation
    this.data.AutomationData(JSON.stringify({automation: "" ,from_email  : "",from_number: ""})).subscribe(res => {
      this.automation = res.result;
      console.log("automation", this.automation);
    })

    // @loading raw leads
    this.getRawLeads();

    // loading dialer's list
    if (sessionStorage.getItem("allcampaign")) {
      this.dialerlist = JSON.parse(sessionStorage.getItem("allcampaign"))
      console.log("dialerlist::", this.dialerlist)
      if (Array.isArray(this.dialerlist) && this.dialerlist.length > 0) {
        this.dialerlist.forEach((ele: any) => {
          this.campIds.push(ele.id)

          // It will store all dialers
          this.vLeadStatus.push({
            id_dialer: ele.id,
            lead_type: 0
          })
          this.vLeadSripts.push({
            id_dialer: ele.id,
            lead_script: 0
          })
        })
        this.campIds.sort()
      }

      // @loading the lead's fields
      this.loadLeadFields()

      // loading custom lead status
      this.loadLeadStatus()

      // loading custom lead script
      this.loadPhoneScript()
    }
console.log("campIds:::", this.campIds);
    this.leaddata.subscribe(res => {
      console.log(res)
      if (res != null) {
        console.log("if==leaddata");

        console.log(res)
        this.dataSource.data = res;
        for (let i = 0; i < res.length; i++) {
          this.allleads[i] = res[i].id;
        }
      }
      else {
        console.log("else==leaddata");
        this.dataSource.data = []
      }
      console.log("this.allleads::", this.allleads)
      this.matTbInit()
    }, err => {
      this.dataSource.data = []
    });

    this.data.getService("leadagent").subscribe(res => {
      console.log("leadstaus", res)
      this.agentList = res
    }, err => {
      this.agentList = []
      console.log("err::", err)
    })

    // getting lead counts
    this.getLeadCounts()

    // loading crm labels
    this.getCRMLabels()

    // loading state's list
    this.data.getOption("state").subscribe(res => {
      console.log(res)
      this.statelist = res
    }, err => {
      this.statelist = []
      console.log("err::", err)
    });

    this.theme.loadlead.subscribe(rss => {
      if (rss != null || rss != undefined) {
        console.log("Current Work Flow::");
        console.log(rss);
        this.campid = rss.campId
        this.checkedLeads = [];
        this.currworkflow = rss.workflow;
        switch (rss.index) {
          case 0: //Report
            {
              if (rss.count == 0) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 1: //Report
            {
              if (rss.count == 0 || rss.count == 1) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 2: //Report
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 3: //Report
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 4: //Report
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3 || rss.count == 4) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 5:
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3 || rss.count == 4 || rss.count == 5) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 6:
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3 || rss.count == 4 || rss.count == 5 || rss.count == 6) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 7:
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3 || rss.count == 4 || rss.count == 5 || rss.count == 6 || rss.count == 7) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 8:
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3 || rss.count == 4 || rss.count == 5 || rss.count == 6 || rss.count == 7 || rss.count == 8) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 9:
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3 || rss.count == 4 || rss.count == 5 || rss.count == 6 || rss.count == 7 || rss.count == 8 || rss.count == 9) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 10:
            {
              if (rss.count == 0 || rss.count == 1 || rss.count == 2 || rss.count == 3 || rss.count == 4 || rss.count == 5 || rss.count == 6 || rss.count == 7 || rss.count == 8 || rss.count == 9 || rss.count == 10) {
                rss.count = rss.count + 1;
                if (rss.utype)
                  this.GetLeads(rss.workflow, rss.iduser);
                else
                  this.GetAllLeads(rss.workflow, rss.iduser);
              }
            }
            break;
          case 15: //-- Display search leads
            {
              this.dataSource.data = rss.sdata;
              this.matTbInit();
            }
            break;
        }
      }
    });

    if (this.fCampIds.length > 0) {
      console.log("sid work", this.fCampIds);
      console.log("sid1", this.allfilter);
    }

    this.theme.leadtype.subscribe((res: any) => {
      console.log(res, "observable");
      let agentId = {
        id: [],
        idA: [0],
        id_leadType: -1,
        id_leadstatus: -1
      }

      this.data.getleadlist(JSON.stringify(agentId)).subscribe(res => {
        if (res != null) {
          console.log(res);
          this.dataSource.data = res;
          for (let i = 0; i < res.length; i++) {
            this.allleads[i] = res[i].id;
          }
        }
      },
        err => {
          this.dataSource.data = [];
        });
    });

  }

  //get agent leads count after click
  GetLeads(workflow: number, user: number) {
    let agentId = { id_leadstatus: workflow.toString(), id_agent: user, id: this.campid ? [this.campid] : [] }
    this.data.getleadlist(JSON.stringify(agentId)).subscribe(res => {
      if (res != null) {
        console.log(res);
        this.dataSource.data = res;
        for (let i = 0; i < res.length; i++) {
          this.allleads[i] = res[i].id;
        }
      }
    },
      err => {
        this.dataSource.data = [];
      });
    this.allChk = false
  }

  GetAllLeads(workflow: number, user: number) {
    console.log("getLeads:");
    console.log("getLeads==else", workflow.toString());
    console.log("getLeads==else", user);
    if (this.keytype == 5) {

      console.log("Get All Leads");
      this.data.getleadlist(JSON.stringify({ id_leadstatus: workflow.toString(), id_agent: user })).subscribe(res => {
        if (res != null) {
          console.log(res);
          this.dataSource.data = res;
          for (let i = 0; i < res.length; i++) {
            this.allleads[i] = res[i].id;
          }
        }
        this.matTbInit();
      },
        err => {
          this.dataSource.data = [];
        });
    }
    else {
      console.log("getLeads==else", workflow.toString());
      console.log("getLeads==else", user);
      this.data.getleadlist(JSON.stringify({ id_leadstatus: -1, id_agent: 0 })).subscribe(res => {
        if (res != null) {
          console.log(res);
          this.dataSource.data = res;
          for (let i = 0; i < res.length; i++) {
            this.allleads[i] = res[i].id;
          }
        }
        this.matTbInit();
      },
        err => {
          this.dataSource.data = [];
        });
    }
    this.allChk = false
  }

  loadLeadFields(): void {
    this.data.GetLeadFields(this.campIds.join()).subscribe(res => {
      console.log("res", res)
      this.leadFields = res || {}
    }, err => {
      this.leadFields = {}
      console.log("err::", err)
    })
  }

  loadLeadStatus(): void {
    this.data.GetLeadStatus(this.campIds.join()).subscribe(res => {
      console.log("res::", res)
      this.fieldArray = res
    }, err => {
      this.fieldArray = []
      console.log("err::", err)
    })
  }

  loadPhoneScript(): void {
    this.data.GetPhoneScript(this.campIds.join()).subscribe(res => {
      console.log("res::", res)
      this.leadscriptList = res
    }, err => {
      this.leadscriptList = []
      console.log("err::", err)
    })
  }

  //total,un-assign,free leads
  getLeadCounts(): void {
    this.samService.gettotallead().subscribe(res => {
      console.log("res::", res)
      if (res != null) {
        // @count total leads
        this.aLeads = res[0].allleads

        // @count free leads
        this.fLeads = res[0].totallead

        // @count free leads
        this.BlankLeads = res[0].blank_leads

        this.getAssignLeadCounts()
      }
    }, err => {
      console.log("err::", err)
    })
  }

  getAssignLeadCounts(): void {
    this.samService.GetAgentLead().subscribe(result => {
      console.log("result::", result)

      // @count assigned leads
      this.taLeads = 0
      for (let x of result) {
        this.taLeads += x.totalagntleads
      }
      this.fLeads = this.aLeads != this.taLeads ? this.fLeads : 0
      this.freeLeads = this.fLeads

      // @count un-allocated leads
      this.unLeads = this.aLeads - this.taLeads - this.fLeads
    }, err => {
      console.log("err::", err)
    })
  }

  getRawLeads(): void {
    this.data.getleadlist(JSON.stringify({ id_leadstatus: -1, id_agent: 0 })).subscribe(res => {
      console.log(res);
      this.__leaddata.next(res);
    }, err => {
      this.__leaddata.next(null);
    });
  }

  cLs(): void {
    this.gInit();
    // @re-load raw leads
    this.getRawLeads();
  }

  // It will store lead status & lead script to make actions on leads
  setLeadData(value: any, id_dialer: number, type: number = 0) {
    console.log("value::", value)

    // for lead type
    if (type == 1) {
      let I1: any = this.vLeadStatus.findIndex((ele: any) => {
        return ele.id_dialer == id_dialer
      })
      if (I1 > -1)
        this.vLeadStatus[I1].lead_type = value
      console.log("vLeadStatus::", this.vLeadStatus)
    }

    // for lead script
    if (type == 2) {
      let I1: any = this.vLeadSripts.findIndex((ele: any) => {
        return ele.id_dialer == id_dialer
      })
      if (I1 > -1)
        this.vLeadSripts[I1].lead_script = value
      console.log("vLeadSripts::", this.vLeadSripts)
    }
  }

  // @actions execution
  mkAc(): void {
    console.log("this.aCampIds::", this.aCampIds)
    console.log("this.aAgentId::", this.aAgentId)
    console.log("this.aLdStatus::", this.aLdStatus)
    console.log("this.aLdType::", this.aLdType)
    console.log("this.automation::", this.auto)

    this.isACt = true

    // @updating dialers
    if (this.aCampIds.length > 0) {
      this.data.acUpdateDialers(JSON.stringify({
        lids: this.checkedLeads,
        campiagn_ids: this.aCampIds,
        lead_type: this.aLdType,
        agent_id: this.aAgentId
      })).subscribe(rs => {
        console.log(rs)
        this.openSnackBar(rs.message, "Clear")
        // Automation apply data 
        if(this.auto)
        this.automationselect();
        // @assigning agents
        this.mkAcAg()

        // @updating lead status
        this.mkAcLS()

        // @updating lead type
        this.mkAcLT()

        setTimeout(() => {
          // @re-load raw leads
          this.getRawLeads()
          this.getLeadCounts()
          // this.openSnackBar("Actions applied successfully", "Clear")

          this.ischecked = false
          this.checkallbox = false
          this.checkedLeads = []
          this.gInit()
          this.isACt = false
        }, 5000)

      })
    } else {
     // Automation apply data
     if(this.auto)
      this.automationselect();
      // @assigning agents
      this.mkAcAg()

      // @updating lead status
      this.mkAcLS()

      // @updating lead type
      this.mkAcLT()

      setTimeout(() => {
        // @re-load raw leads
        this.getRawLeads()
        this.getLeadCounts()
        this.openSnackBar("Actions applied successfully", "Clear")

        this.ischecked = false
        this.checkallbox = false
        this.checkedLeads = []
        this.gInit()
        this.isACt = false
      }, 5000)
    }
    setTimeout(() => {
      this.selection.clear() 
    }, 2000);
  }

  // @to update the agents
  mkAcAg(): void {
    console.log(this.aAgentId,this.aAgentId_forcheck);
    
    if (this.aAgentId >= 0 && this.aAgentId!= this.aAgentId_forcheck) {
      this.data.acUpdateAgent(JSON.stringify({
        lids: this.checkedLeads,
        agent_id: this.aAgentId
      })).subscribe(rs => {
        console.log(rs)
        this.openSnackBar(rs.message, "Clear")
      })
    }
  }

  // @to update the lead status
  mkAcLS(): void {
    if (this.vLS1 >= 0 || this.vLS2 >= 0 || this.vLS3 >= 0) {
      this.data.acUpdateLeadStatus(JSON.stringify({
        lids: this.checkedLeads,
        // lead_status: this.aLdStatus,
        vLS1: this.vLS1,
        vLS2: this.vLS2,
        vLS3: this.vLS3,
        aCampIds: this.aCampIds
      })).subscribe(rs => {
        console.log(rs)
        this.openSnackBar(rs.message, "Clear")
      })
    }
  }

  // @to update the lead type
  mkAcLT(): void {
    if (this.vLSrc1 >= 0 || this.vLSrc2 >= 0 || this.vLSrc3 >= 0) {
      this.data.acUpdateLeadScript(JSON.stringify({
        lids: this.checkedLeads,
        // lead_type: this.aLdType,
        vLSrc1: this.vLSrc1,
        vLSrc2: this.vLSrc2,
        vLSrc3: this.vLSrc3,
        aCampIds: this.aCampIds
      })).subscribe(rs => {
        console.log(rs)
        this.openSnackBar(rs.message, "Clear")
      })
    }
  }

  // @export selected leads
  exportSLeads(): void {
    const dialogRef = this.dialog.open(ExportleadsComponent, {
      disableClose: true,
      width: '1440px',
      data: {
        leadsColumns: this.leadsColumns,
        leadFields: this.leadFields
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed')
      console.log("result::", JSON.stringify(result))
      if (result.etype) {
        // @to export csv file of leads
        if (result.etype == 1) {
          console.log(this.checkedLeads)
          let filename = sessionStorage.getItem("firstname") + "_AllLeads";
          // var str = "{\"filename\" : \"" + filename + "\"}";
          let str: string = ""
          this.data.Download('sLeads', str, JSON.stringify({
            lids: this.checkedLeads,
            filename: filename,
            sLeadsColumns: result.sLeadsColumns,
            id_dialer: result.id_dialer,
            dialer_columns: result.dialer_columns
          })).subscribe(ress => {
            saveAs(ress, filename + ".csv");
          })
        }

        // @to export leads into zapier
        if (result.etype == 2) {
          // @making upload into zapier
          this.data.getFilteredLedas(JSON.stringify({
            lids: this.checkedLeads,
            sLeadsColumns: result.sLeadsColumns,
            id_dialer: result.id_dialer,
            dialer_columns: result.dialer_columns
          })).subscribe(res => {
            console.log('res' + res);
          })
        }

      }
    });
  }

  View(edit: any) {
    console.log(edit);
    const dialogRef = this.dialog.open(ViewleadComponent, {
      disableClose: true,
      maxWidth: '100vw',
      width: '3500px',

      data: {
        edit
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      // this.animal = result;
    });
  }

  editLead(result: any): void {
    console.log("result::", result)

    // It will filter with avilable dialers
    let idDialers: any = result.id_dialer.split(",") || []
    let CampIds: any = []
    let id_lead: number = result.id

    idDialers = idDialers.filter((item: any, index: any) => {
      return idDialers.indexOf(item) == index
    }).sort()
    console.log("idDialers::", idDialers)

    idDialers.forEach((ele: any) => {
      ele = parseInt(ele)
      let I: any = this.dialerlist.findIndex((ele2: any) => {
        return ele2.id == ele
      })
      if (I > -1)
        CampIds.push(ele)
    })
    idDialers = CampIds

    // It will set Raw data to edit
    let I: any = this.leadFields.RawHeader.findIndex((ele: any) => {
      return ele.fields == 'state'
    })
    this.leadFields.RawHeader.splice(I, 1)
    this.leadFields.RawHeader.forEach((ele: any) => {
      ele[ele.fields] = ""
      for (const [key, value] of Object.entries(result)) {
        if (key == ele.fields) {
          ele[ele.fields] = value
          break
        }
      }
    })

    // It will load single lead's data
    let pR = new Promise((resolve, reject) => {
      this.data.GetSingleLeadData(result.id.toString()).subscribe(res => {
        console.log("res::", res)
        let lead_data: any = res.data

        // It will set Dialer's data to edit
        for (let x1 of this.leadFields.Dialers) {
          let I: any = lead_data.custom_fields.findIndex((ele3: any) => {
            return ele3.id_dialer == x1.id_dialer
          })

          if (I > -1) {
            x1.header.forEach((ele: any) => {
              ele[ele.fields] = ""
              for (const [key, value] of Object.entries(lead_data.custom_fields[I])) {
                if (key == ele.fields) {
                  ele[ele.fields] = value
                  break
                }
              }
            })
          } else {
            x1.header.forEach((ele: any) => {
              ele[ele.fields] = ""
            })
          }
        }
        resolve(true)
      }, err => {
        console.log("err::", err)
        resolve(true)
      })
    })

    pR.then(res => {
      console.log("res::", res)

      let leadFields: any = this.leadFields,
        id_state: string = result.state,
        type: number = 1

      const dialogRef = this.dialog.open(SingleleadComponent, {
        disableClose: true,
        width: '1500px',
        data: {
          leadFields: leadFields,
          id_state: id_state,
          stateList: this.statelist,
          ActDialers: idDialers,
          type: type,
          is_update: 1
        }
      })
      dialogRef.afterClosed().subscribe(res => {
        console.log('The dialog was closed')
        console.log(res)
        if (res != null || res != undefined) {
          if (res.isC) {

            let leadData: any = res.leadFields

            // It will remove extra fields from json
            // to filter raw fields
            let nR: any[] = []
            leadData.RawHeader.forEach((ele: any) => {
              let oC: any = Object.entries(ele)[Object.entries(ele).length - 1],
                oN: any = Object.create({})

              oN[oC[0]] = oC[1]
              nR.push(oN)
            })
            leadData.RawHeader = nR

            // to filter dialer-wise fields
            leadData.Dialers.forEach((ele: any) => {
              let nR: any[] = []
              ele.header.forEach((ele2: any) => {
                let oC: any = Object.entries(ele2)[Object.entries(ele2).length - 1],
                  oN: any = Object.create({})

                oN[oC[0]] = oC[1]
                nR.push(oN)
              })
              ele.header = nR
            })

            let sDt: any = JSON.stringify({
              leadData: {
                Dialers: leadData.Dialers,
                RawHeader: leadData.RawHeader
              },
              id_state: res.id_state,
              campaigns: CampIds,
              id_lead: id_lead
            })

            console.log("submitted::", sDt)

            this.data.updateLead(sDt, id_lead).subscribe(rs => {
              console.log(rs)
              this.openSnackBar(rs.message, "Clear")
              this.getRawLeads()
              this.loadLeadFields()
            })
          }
        }
      }, err => {
        console.log("err::", err)
      })
    }).catch(err => {
      console.log("err::", err)
    })
  }

  Delete(event: any) {
    console.log(event);
    const dialogRef = this.dialog.open(AlertComponent, {
      disableClose: true,
      width: '600px',
      data: {
        name: event,
        type: 1
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != null || result != undefined) {
        this.data.deleteLeads(result).subscribe(res => {
          console.log(res);
          this.theme.loadlead.subscribe(rss => {
            console.log(rss)
            this.GetAllLeads(rss.workflow, rss.iduser)
          })
          this.openSnackBar("Lead Deleted successully", "Clear");

          // @re-load raw leads

          this.getRawLeads()
          this.getLeadCounts()
          this.ischecked = false
          this.checkallbox = false
          this.checkedLeads = []
          this.gInit()
        });
      }
    });
  }

  RemoveAuto(data: any) {
    console.log(data);
    const dialogRef = this.dialog.open(AlertComponent, {
      disableClose: true,
      width: '600px',
      data: {
        name: "",
        leads: 1,
        type: 8
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null || result != undefined) {
        console.log("removeAuto:", data.id);
        this.data.removeAutomation(data.id).subscribe(res => {
          this.openSnackBar(res.message, "Clear");
          this.data.getleadlist(JSON.stringify({ id_leadstatus: -1, id_agent: 0 })).subscribe(res => {
            if (res != null) {
              console.log(res);
              this.dataSource.data = res;
              for (let i = 0; i < res.length; i++) {
                this.allleads[i] = res[i].id;
              }
            }
            this.matTbInit();
          },
            err => {
              this.dataSource.data = [];
            })
        })
      }
    })

  }

  OnallCkeck(events: any) {
    this.auto = '';
    console.log(events);
    console.log("this.pgSI::", this.pgSI)
    console.log("this.pgEI::", this.pgEI)
    console.log("this.pgEI::", this.allleads)

    this.checkedLeads = [];
    this.autoDelete = []
    if (events.checked) {
      this.ischecked = true;
      this.checkallbox = true;

      // @mapping filtered leads
      for (let i = this.pgSI; i <= this.pgEI; i++) {

        this.checkedLeads.push(this.allleads[i]);
        let arry = this.dataSource.data
        if (arry[i].automation) {
              this.autoDelete.push(arry[i].id);
        }
        
      }
      let dailers =[]
      this.dataSource.data.forEach((ele1:any)=>{
        this.checkedLeads.forEach((ele2:any)=>{
          if(ele1.id==ele2){
             let split:any = ele1.id_dialer.split(",")
             dailers.push(...split);
          }
        })
      })
      console.log(dailers);
      let uniqueChars = dailers.filter((c: any, index: any) => {
        return dailers.indexOf(c) === index;
      });
      var resultss = uniqueChars.map(function (x) {
        return parseInt(x, 10);
      });
      this.aCampIds = resultss;

      // console.log(this.dataSource.data);
      // this.checkedLeads = this.allleads
      console.log("TRUE", this.autoDelete);
    } else {
      console.log("FALSE");
      this.ischecked = false;
      this.checkallbox = false;
      this.checkedLeads = [];
      this.autoDelete = []
    }
    console.log("this.checkedLeads::", this.checkedLeads)
  }

  OnSingleCkeck(events: any, index: number, element: any) {
    console.log("ereeeeeeee", element)
    this.ischecked = true;
    let leadid = element.id
    this.aAgentId = element.id_agent
    this.aAgentId_forcheck = element.id_agent
    // let dlrid = element.id_dialer
    // console.log(dlrid)
    // let sty: any = dlrid.split(",")
    // console.log(sty)
    // let uniqueChars = sty.filter((c: any, index: any) => {
    //   return sty.indexOf(c) === index;
    // });
    // var result = uniqueChars.map(function (x) {
    //   return parseInt(x, 10);
    // });
    // this.aCampIds = result;
    console.log("Check :: " + events.checked + "  INDEX:: " + index + " LEAD:: " + leadid);
    if (events.checked) {
      this.checkedLeads.push(leadid);
      console.log(this.checkedLeads);
      let dailers =[]
      this.dataSource.data.forEach((ele1:any)=>{
        this.checkedLeads.forEach((ele2:any)=>{
          if(ele1.id==ele2){
             let split:any = ele1.id_dialer.split(",")
             dailers.push(...split)
          }
        })
      })
      console.log(dailers);
      let uniqueChars = dailers.filter((c: any, index: any) => {
        return dailers.indexOf(c) === index;
      });
      var resultss = uniqueChars.map(function (x) {
        return parseInt(x, 10);
      });
      this.aCampIds = resultss;


      if (element.automation) {
        this.autoDelete.push(leadid)
      }
      if (this.checkedLeads.length > 24) {
        this.allChk = true;
      }
    }
    else {
      this.allChk = false;
      let crindex = this.checkedLeads.findIndex(function (ele, i) {
        return ele === leadid
      });
      this.checkedLeads.splice(crindex, 1);
      //this.checkedLeads[index]=-1;
      if (element.automation) {
        let auto = this.autoDelete.findIndex((ele) => {
          return ele.id === leadid
        })
        this.autoDelete.splice(auto, 1)
      }
      console.log(this.checkedLeads);
      
      let dailers =[]
      this.dataSource.data.forEach((ele1:any)=>{
        this.checkedLeads.forEach((ele2:any)=>{
          if(ele1.id==ele2){
             let split:any = ele1.id_dialer.split(",")
             dailers.push(...split)
          }
        })
      })
      console.log(dailers);
      
      let uniqueChars = dailers.filter((c: any, index: any) => {
        return dailers.indexOf(c) === index;
      });
      var resultss = uniqueChars.map(function (x) {
        return parseInt(x, 10);
      });
      this.aCampIds = resultss;
    }
    console.log("this.checkedLeads::", this.checkedLeads)
    console.log("testt", this.autoDelete)
    this.dDialer()
  }


  onChangeFilter(event: any, type: string) {
    console.log("event", type);
    console.log("fCampIds:", this.fCampIds);
    console.log("fAgentIds:", this.fAgentIds);
    console.log("fLdStatus:", this.fLdStatus);
    console.log("fLdType:", this.fLdType);
    console.log("auto:", this.fauto);
    if (this.fCampIds.length == 0 && this.fAgentIds.length == 0 && this.fLdStatus.length == 0 && this.fLdType == -1) {
      this.disableLeadStatus(this.fCampIds);
      this.data.getleadlist(JSON.stringify({ id_leadstatus: -1, id_agent: 0 })).subscribe(res => {
        this.__leaddata.next(res);
      })
      return
    }

    let count: number = 0
    if (type == 'id_dialer') {
      this.disableLeadStatus(event.value);
      this.fLdStatus = [-1];
      if (this.fCampIds.length > 0) {
        this.allfilter[type] = this.fCampIds;
      }
      else {
        this.allfilter[type] = -1;
      }
    }

    // @to filter with agents
    if (type == 'id_agent') {
      if (this.fAgentIds.length > 0)
        this.allfilter[type] = this.fAgentIds;
      else
        this.allfilter[type] = 0;
    }

    // @to filter with lead status
    if (type == 'id_leadstatus') {
      if (this.fCampIds.length == 0 || this.fCampIds.length > 1) {
        let temparr = []
        temparr.push(this.fLdStatus[1])
        this.fCampIds = temparr
        this.disableLeadStatus(temparr);
      }
      this.allfilter[type] = this.fLdStatus;
    }

    // @to filter with lead type
    if (type == 'lead_type')
      this.allfilter[type] = this.fLdType;

    this.strfltr = {
      id: this.fCampIds,
      idA: this.fAgentIds,
      id_leadstatus: this.fLdStatus[0],
      id_leadType: this.fLdType,
      automation: this.fauto
    }
    console.log("strfltr", this.strfltr);

    this.data.getleadlist(JSON.stringify(this.strfltr)).subscribe(res => {
      this.__leaddata.next(res);
      console.log("resukt", res);

      this.dataSource.data = res
    }, err => {
      console.log("err::", err)
      this.dataSource.data = [];
    })
  }

  // onChangeFilter(event: any, type: string) {

  //   console.log("event",event);
  //   console.log("type",type);
  //   if (this.fCampIds.length == 0){
  //     return
  //   }
  //   let count: number = 0
  //   let strfltr: string = "";

  //   // @to filter with dialer
  //   if (type == 'id_dialer') {
  //     if (this.fCampIds.length > 0){
  //       console.log("sid",this.fCampIds);
  //       console.log("sid1",this.allfilter);
  //       this.allfilter[type] = this.fCampIds;}
  //     else
  //       this.allfilter[type] = -1;
  //   }

  //   // @to filter with agents
  //   if (type == 'id_agent') {
  //     if (this.fAgentIds.length > 0)
  //       this.allfilter[type] = this.fAgentIds;
  //     else
  //       this.allfilter[type] = -1;
  //   }

  //   // @to filter with lead status
  //   if (type == 'id_leadstatus')
  //     this.allfilter[type] = this.fLdStatus;

  //   // @to filter with lead type
  //   if (type == 'lead_type')
  //     this.allfilter[type] = this.fLdType;

  //   console.log(this.allfilter);

  //   let iC: number = 0
  //   // this.allfilter.forEach([(key:any,val:any)])=>{
  //   Object.entries(this.allfilter).forEach(([key, val]) => {
  //     /* count++; */
  //     console.log(this.allfilter);
  //     if (val != -1) {
  //       strfltr += "b." + key + " =" + val + " ";
  //     }
  //     console.log("sudhanshu",strfltr)
  //     console.log(this.allfilter.length + '==' + count);

  //     iC++
  //   });
  //   console.log(this.allfilter.length);

  //   // @make filter with filtered parameters
  //   if (iC > 0) {
  //     // strfltr = "AND " + strfltr
  //     // getleadlistFilter AND b.id_dialer IN (1)
  //     // strfltr = strfltr.slice(0, -5);
  //     console.log("strfltr",strfltr);

  //     this.data.getleadlist(JSON.stringify(strfltr)).subscribe(res => {
  //       console.log("leads::", res);

  //       this.__leaddata.next(res);

  //       // this.dataSource.data=res

  //   }
  //     , err => {
  //       console.log("err::", err)

  //       this.dataSource.data = [];
  //     });
  //   }

  // }

  deleteSLeads() {
    const dialogRef = this.dialog.open(AlertComponent, {
      disableClose: true,
      width: '600px',
      data: {
        name: "",
        leads: this.checkedLeads.length,
        type: 4
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != null || result != undefined) {
        let aL: string = this.checkedLeads.join()
        this.data.deleteSLeads(aL).subscribe(res => {
          console.log(res);
          this.openSnackBar("Leads deleted successully", "Clear");

          // @re-load raw leads
          this.getRawLeads()
          this.getLeadCounts()
          this.ischecked = false
          this.checkallbox = false
          this.checkedLeads = []
          this.gInit()

        });
      }
    });
  }


  deleteMultiAuto() {
    const dialogRef = this.dialog.open(AlertComponent, {
      disableClose: true,
      width: '600px',
      data: {
        name: "",
        leads: this.autoDelete.length,
        type: 8
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != null || result != undefined) {
        let aL: string = this.autoDelete.join()
        console.log(aL);
        this.data.removeAutomation(aL).subscribe(res => {
          this.openSnackBar(res.message, "Clear");
          this.data.getleadlist(JSON.stringify({ id_leadstatus: -1, id_agent: 0 })).subscribe(res => {
            if (res != null) {
              console.log(res);
              this.dataSource.data = res;
              for (let i = 0; i < res.length; i++) {
                this.allleads[i] = res[i].id;
              }
            }
            this.matTbInit();
             this.selection.clear() 
          },
            err => {
              this.dataSource.data = [];
            })
        })
      }
    });
  }

  changePage(e: any): void {
    console.log(e)
    this.pgSI = e.pageIndex * e.pageSize

    this.pgSize = e.pageSize
    this.pgEI = this.pgSI == 0 ? (this.pgSize - 1) : (this.pgSI + this.pgSize) - 1

    if (this.dataSource.data.length < this.pgEI) {
      this.pgEI = this.dataSource.data.length - 1
    }

    console.log("this.pgSI::", this.pgSI)
    console.log("this.pgEI::", this.pgEI)
    this.OnallCkeck({
      checked: false
    })
    this.allChk = false
  }

  getCRMLabels(): void {
    this.data.getCRMLabels(this.currcampId).subscribe(res => {
      console.log("res::", JSON.stringify(res))
      this.leadsColumns = res
    })
  }

  // @mat-table configuration
  selection = new SelectionModel<Lead>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    // const numRows = this.dataSource.data.length;
    const numRows = this.dataSource.paginator.pageSize;
    // console.log('ssssss', numSelected, "ssssssd", numRows)
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(event:any) {
    event.checked ?
    this.dataSource.data.forEach((row:any,index:any) =>{
      this.checkedLeads.forEach((ele:any) => {
        if(ele == row.id){
          this.selection.select(row)
        }
      });
    }):this.selection.clear()

  }
  // selectRows() {
  //   for (let index = 0; index < this.dataSource.paginator.pageSize; index++) {
  //     this.selection.select(this.dataSource.data[index]);
  //     this.selectionAmount = this.selection.selected.length;
  //   }
  // }

  abc() {
    $('#myDropdown .dropdown-menu').on({
      "click": function (e) {
        e.stopPropagation();
      }
    });
    $('.closer').on('click', function () {
      $('.btn-group').removeClass('open');
    });
  }

  dDialer(): void {

    console.log("aCampIds::", this.aCampIds)

    // @Dialer selection for lead status
    // It will remove unchecked dialer's data from selected list
    let rD: any[] = this.acLeadStatus
    this.acLeadStatus.forEach((x: any, i: any) => {
      let I: any = this.aCampIds.findIndex((ele: any) => {
        return ele == x.id_dialer
      })
      console.log("I1::", I)
      if (I < 0)
        rD.splice(i, 1)
    })
    this.acLeadStatus = rD

    // It will append dialer's data into selected list
    for (let x of this.aCampIds) {
      let I2: any = this.fieldArray.findIndex((ele: any) => {
        return ele.id_dialer == x
      })
      console.log("I2::", I2)
      if (I2 > -1) {
        let I3: any = this.acLeadStatus.findIndex((ele: any) => {
          return ele.id_dialer == x
        })
        if (I3 < 0)
          this.acLeadStatus.push(this.fieldArray[I2])
      }
    }


    // @Dialer selection for lead scripts
    // It will remove unchecked dialer's data from selected list
    let rD2: any[] = this.acLeadSripts
    this.acLeadSripts.forEach((x: any, i: any) => {
      let I: any = this.aCampIds.findIndex((ele: any) => {
        return ele == x.id_dialer
      })
      console.log("I3::", I)
      if (I < 0)
        rD2.splice(i, 1)
    })
    this.acLeadSripts = rD2

    // It will append dialer's data into selected list
    for (let x of this.aCampIds) {
      let I2: any = this.leadscriptList.findIndex((ele: any) => {
        return ele.id_dialer == x
      })
      console.log("I4::", I2)
      if (I2 > -1) {
        let I3: any = this.acLeadSripts.findIndex((ele: any) => {
          return ele.id_dialer == x
        })
        if (I3 < 0)
          this.acLeadSripts.push(this.leadscriptList[I2])
      }
    }
  }

  SelectAllLeads(type: number = 0) {
    console.log("allselected",)
    console.log("type::", type)
    if (type == 1) {
      this.checkedLeads = this.allleads
      this.dataSource.data.forEach(row => this.selection.select(row));
      this.dataSource.data.forEach((ele: any, i: any) => {
        if (ele.automation) {
          this.autoDelete.push(ele.id)
        }
      })
    }
    if (type == 2) {
      this.checkedLeads = []
      this.autoDelete = []
    }
    console.log("this.checkedLeads::", this.checkedLeads)
  }

  onclick() {
    this.visible = !this.visible
  }

  // @----------------------un-used methods-----------------------@//

  // GetLeads(workflow: number, user: number) {
  //   this.data.getleadlist().subscribe(res => {
  //     this.__leaddata.next(res);
  //   });
  // }


  // GetAllLeads(workflow: number, user: number) {
  //   if (this.keytype == 5) {
  //     console.log("Get All Leads");
  //     this.data.getleadlist().subscribe(res => {
  //       this.__leaddata.next(res);
  //     });
  //   }
  //   else {
  //     this.data.getleadlist().subscribe(res => {
  //       this.__leaddata.next(res);
  //     });
  //   }
  // }


  // Editlead(result: any) {
  //   console.log(result);
  //   const dialogRef = this.dialog.open(LeadeditComponent, {
  //     disableClose: true,
  //     width: '2500px',
  //     data: { result, statelist: this.statelist, countylist: this.countylist, citylist: this.citylist, ziplist: this.ziplist }
  //   });
  //   dialogRef.afterClosed().subscribe(res => {
  //     if (res != null || res != undefined) {
  //       this.data.updateLead(JSON.stringify({ formdata: res.fromdata, leadid: res.leadid }), res.leadid).subscribe(rs => {
  //         console.log(rs);
  //         this.openSnackBar(rs.message, "Clear");
  //         this.getRawLeads()
  //         // this.GetAllLeads(res.fromdata.id_leadstatus, parseInt(sessionStorage.getItem('userid')));
  //       });
  //     }
  //   });
  // }


  // UpdateLeadType(event: any) {
  //   console.log(event);
  //   const dialogRef = this.dialog.open(LeadscriptComponent, {
  //     disableClose: true,
  //     width: '2500px',
  //     data: { event }
  //   });
  //   dialogRef.afterClosed().subscribe(res => {
  //     if (res != null && res != undefined) {
  //       this.data.updateLeadScript(JSON.stringify({ formdata: res.leadType, leadid: res.leadID }), res.leadID).subscribe(rs => {
  //         console.log(rs);
  //         this.openSnackBar(rs.message, "Clear");
  //         this.GetAllLeads(this.currworkflow, parseInt(sessionStorage.getItem('userid')));
  //         this.ischecked = false;
  //         this.checkallbox = false;
  //         this.checkedLeads = [];
  //       });
  //     }
  //   });
  // }


  // UpdateLeadStatus(event: any) {
  //   console.log(event);
  //   const dialogRef = this.dialog.open(LeadstatusComponent, {
  //     disableClose: true,
  //     width: '2500px',
  //     data: { event }
  //   });
  //   dialogRef.afterClosed().subscribe(res => {
  //     console.log(res);
  //     if (res != null && res != undefined) {
  //       this.data.updateLeadStatus(JSON.stringify({ formdata: res.leadType, leadid: res.leadID }), res.leadID).subscribe(rs => {
  //         console.log(rs);
  //         this.openSnackBar(rs.message, "Clear");
  //         this.GetAllLeads(this.currworkflow, parseInt(sessionStorage.getItem('userid')));
  //         this.ischecked = false;
  //         this.checkallbox = false;
  //         this.checkedLeads = [];
  //       });
  //     }
  //   });
  // }


  // onBulkDelete() {
  //   console.log(this.checkedLeads);
  //   if (this.checkedLeads.length > 0) {
  //     const dialogRef = this.dialog.open(AlertComponent, {
  //       disableClose: true,
  //       width: '600px',
  //       data: { name: '', leads: this.checkedLeads.length, type: 4 }
  //     });
  //     dialogRef.afterClosed().subscribe(result => {
  //       console.log(result);
  //       if (result != null && result != undefined) {
  //         this.data.DeleteDuplicateLeads(JSON.stringify({ leadid: this.checkedLeads })).subscribe(res => {
  //           this.openSnackBar(res.message, "Clear");
  //           this.GetAllLeads(0, parseInt(sessionStorage.getItem('userid')));
  //           this.ischecked = false;
  //           this.checkallbox = false;
  //           this.checkedLeads = [];
  //         });
  //       }
  //     });
  //   }
  //   else {
  //     alert("Please Select Atleat One Row");
  //   }
  // }


  // UpdateBulkLeadType() {
  //   if (this.checkedLeads.length > 0) {
  //     this.UpdateLeadType({ lead_type: 0, id: this.checkedLeads });
  //   }
  //   else {
  //     alert("Please Select Atleat One Row");
  //   }
  // }


  // BulkUpdateLeadStatus() {
  //   if (this.checkedLeads.length > 0) {
  //     this.UpdateLeadStatus({ id_leadstatus: 0, id: this.checkedLeads });
  //   }
  //   else {
  //     alert("Please Select Atleat One Row");
  //   }
  // }

  CallNow(leadid: any, campaignid: any) {
    let campaign = campaignid.split(',');
    this.allcamp.find((item: any) => {
      if (item.id == parseInt(campaign))
        this.currcampflag = item.dialer_type
    })
    if (campaign[0].length > 0) {
      if (parseInt(sessionStorage.getItem("id_package")) > -1) {
        this.data.getcallerid("getcallerid", { id_campaign: campaign[0] }).subscribe((res: any) => {
          console.log(res);
          if (res[0].number != null && res[0].number != undefined) {
            sessionStorage.setItem('currcampflag', this.currcampflag.toString());
            sessionStorage.setItem('currcampaign', campaign[0].toString());
            sessionStorage.setItem("loadlead", leadid.toString());
            this.router.navigate(['/dialer'])
              .then(() => {
                location.reload(true);
              })
          }
          else
            alert("Please Purchase a CallerID for  Dialer");
        },
          err => {
            alert("Please Purchase a CallerID for Dialer");
          });
      }
      else {
        alert("You not have Active Subscription for Dialer");
      }
    }
    else {
      alert("Please assign lead to dialer. Then you will be able to call this lead!")
    }
  }

  automationselect() {
    console.log("select automation", this.auto, this.checkedLeads)
    let Autolead = { autoID: this.auto, leadID: this.checkedLeads }
    this.data.sendAuto(Autolead).subscribe(res => {
      console.log("AutoLeadData:", res);
      this.openSnackBar(res.message, "Clear")
    })
  }
  disableLeadStatus(dailer: any) {
    this.fieldArray.forEach((ele: any) => {
      ele.arrays.forEach((element: any) => {
        if (dailer.length > 0)
          element.disabled = true;
        else
          element.disabled = false;
        dailer.forEach((dail: any) => {
          if (dail == ele.id_dialer) {
            element.disabled = false;
          }
        });
      })
    })
  }

  openviewlead(leadid: any, campaignid: any) {
    let campaign = campaignid.split(',');
    this.allcamp.find((item: any) => {
      if (item.id == parseInt(campaign))
        this.currcampflag = item.dialer_type
    })
    // console.log('test');
    sessionStorage.setItem('currcampflag', this.currcampflag.toString());
    sessionStorage.setItem('currcampaign', campaign[0].toString());
    sessionStorage.setItem("loadlead", leadid.toString());
    this.router.navigate([`/lead/leaddetails`]).then()
  }


  changeState(val): void {
    if (this.filterIconVal == "2") {
      this.filterIconVal = "1";
    }
    else {
      this.filterIconVal = "2";
    }
  }

}
// @custom pipe for line break
@Pipe({
  name: 'LineBreak'
})
export class LineBreakPipe implements PipeTransform {
  transform(val: any) {
    console.log("val::", val)
    return true
  }
}

// // @custom pipe for data filtering
// @Pipe({
//   name: 'FilterData'
// })
// export class OrdinalPipe implements PipeTransform {

//   transform(value: number, curdata: any): string {
//     var data = curdata.filter(
//       element => element.agents === value);
//     return data[0].name;
//   }
// }
